import React, { useContext } from 'react';
import { observer } from 'mobx-react';

import { DerpContext } from 'contexts';

import Toast from './toast';

import { Container } from './toasts-style';

const Toasts = observer(() => {
  const { toasts } = useContext(DerpContext);
  const toastsList = toasts.get();
  return (
    <Container>
      {toastsList.map(toast => (
        <Toast key={`key-${toast.id}`} {...toast} toasts={toasts} />
      ))}
    </Container>
  );
});

export default Toasts;
